export default {
  en: {
    '支付账户 · 资金账户': 'Payment account · Funding account',
    '正在加载可购买额度…': 'Loading available purchase amounts…',
    '暂无可购买额度': 'No purchase amounts available',
    '预计获得': 'Estimated points',
    '（1 USDT = 1 点）': '(1 USDT = 1 point)',
    '点卡仅用于抵扣平台服务费，不可提现、退换或转让；消费时优先于燃料账户扣除。': 'Points can only be used to offset platform service fees. They cannot be withdrawn, refunded, exchanged, or transferred, and are deducted before the fuel account.',
    '可提现金额：': 'Withdrawable amount:',
    '机器人运行的前提': 'Required for bot operation',
    '之前完成付款，超时请重新生成充值订单。': 'Complete payment before the deadline. Generate a new deposit order if it expires.',
    '，否则系统无法确认充值成功；金额不一致时系统无法找回。': ', otherwise the system cannot confirm the deposit. Funds cannot be recovered if the amount does not match.',
    '我已完成充值': 'I have completed the deposit',
    '盈利预期马丁策略': 'Expected-profit Martingale strategy',
    '双马丁策略': 'Dual Martingale strategy',
    '做单数量': 'Order quantity',
    '止盈回调 (%)': 'Take-profit retracement (%)',
    '亏损补偿比例 (%)': 'Loss compensation ratio (%)',
    '持仓比例 (%)': 'Position ratio (%)',
    '恢复后的最大持仓': 'Maximum position after resuming',
    '做单数量变化时，补仓配置将同步更新。': 'The replenishment configuration updates when the order quantity changes.',
    'Astra 最小投入 100 USDT': 'Astra minimum investment: 100 USDT',
    'U 本位': 'USDT-margined',
    '做多': 'Long',
    '做空': 'Short',
    '亏损补偿比例': 'Loss compensation ratio',
    '重置成功后，所有已登录设备将被强制退出；交易所 API 绑定不受影响。': 'After a successful reset, all signed-in devices will be logged out. Exchange API bindings will not be affected.',
    '上一页': 'Previous',
    '下一页': 'Next',
    '收益构成基于本月已结算数据统计，每日 00:00 更新。': 'Earnings composition is based on this month’s settled data and updates daily at 00:00.',
    '少': 'Low',
    '本月累计已结算 (USDT)': 'Settled this month (USDT)',
    '最佳单日': 'Best day',
    '盈利天数': 'Profitable days',
    '日均收益': 'Average daily earnings',
    '收益日历按自然日统计已结算收益，绿色越深代表当日收益越高；悬停单元格可查看每日明细。': 'The earnings calendar shows settled earnings by calendar day. Darker green indicates higher earnings; hover over a cell for daily details.',
    '查看公告、交易动态及系统消息': 'View announcements, trading updates, and system messages',
    '正在同步未读数量…': 'Syncing unread count…',
    '只读 + 交易授权，无提现权限，资产始终留在你自己的交易所账户': 'Read-only and trading permissions, with no withdrawal access. Assets always remain in your own exchange account.',
    '支持交易所': 'Supported exchanges',
    '重新绑定': 'Rebind',
    '已加密保存': 'Encrypted and saved',
    '只读': 'Read-only',
    '禁止提现': 'Withdrawals disabled',
    '暂无可绑定的交易所': 'No exchanges available to bind',
    '密钥经 AES-256 加密存储，仅用于查询与下单，平台无法提现你的资产；建议在交易所侧同时设置 IP 白名单。': 'Keys are stored with AES-256 encryption and used only for queries and orders. The platform cannot withdraw your assets. We recommend setting an IP allowlist on the exchange.',
    '头像': 'Avatar',
    '选择图片': 'Choose image',
    '支持 JPG / PNG，文件不超过 4MB': 'JPG / PNG supported, up to 4 MB',
    '昵称将显示在顶栏与收益榜（脱敏展示）': 'Your nickname appears in the header and earnings ranking in masked form',
    '更换交易所请返回列表': 'Return to the list to change exchanges',
    'Passphrase 必须与 OKX 保持一致，不能包含中文、非英文字符或空格': 'The passphrase must match OKX and cannot contain Chinese characters, non-English characters, or spaces',
    '授权范围': 'Permission scope',
    '密钥经 AES-256 加密存储，仅用于查询与下单；请勿开启提现权限，建议同时设置 IP 白名单。': 'Keys are stored with AES-256 encryption and used only for queries and orders. Do not enable withdrawal permission; we recommend setting an IP allowlist.',
    '不知道如何创建 API？': 'Not sure how to create an API?',
    '查看图文教程': 'View illustrated guide',
    '恢复运行': 'Resume operation',
    '重新读取': 'Reload',
    '实时同步': 'Live sync',
    '至': 'to',
    '仓位数据来自当前交易所；暂停策略不会自动平仓。': 'Position data comes from the current exchange. Pausing a strategy does not automatically close positions.',
    '马丁策略控制': 'Martingale controls',
    '管理补仓、止盈与循环操作': 'Manage replenishment, take-profit, and cycle operations',
    '当前挂单': 'Current open orders',
    '已实现盈亏': 'Realized P&L',
    '策略参数': 'Strategy parameters',
    '当前策略配置': 'Current strategy configuration',
    '当前没有可展示的策略参数': 'No strategy parameters to display',
    '本次补仓后停止继续补仓': 'Stop further replenishment after this order',
    '操作完成后同时停止策略': 'Stop the strategy after the operation completes',
    '该循环或网格订单的成交记录': 'Trades for this cycle or grid order',
    '正在读取成交明细…': 'Loading trade details…',
    '盈亏': 'P&L'
  },
  ko: {
    '支付账户 · 资金账户': '결제 계정 · 자금 계정',
    '正在加载可购买额度…': '구매 가능 금액을 불러오는 중…',
    '暂无可购买额度': '구매 가능한 금액이 없습니다',
    '预计获得': '예상 포인트',
    '（1 USDT = 1 点）': '(1 USDT = 1포인트)',
    '点卡仅用于抵扣平台服务费，不可提现、退换或转让；消费时优先于燃料账户扣除。': '포인트는 플랫폼 서비스 수수료 차감에만 사용할 수 있으며 출금, 환불, 교환 또는 양도할 수 없습니다. 사용 시 연료 계정보다 먼저 차감됩니다.',
    '可提现金额：': '출금 가능 금액:',
    '机器人运行的前提': '봇 운영 필수 조건',
    '之前完成付款，超时请重新生成充值订单。': '기한 내 결제를 완료하세요. 만료되면 새 충전 주문을 생성하세요.',
    '，否则系统无法确认充值成功；金额不一致时系统无法找回。': '을(를) 사용해야 합니다. 그렇지 않으면 충전을 확인할 수 없으며 금액이 다르면 복구할 수 없습니다.',
    '我已完成充值': '충전을 완료했습니다',
    '盈利预期马丁策略': '예상 수익 마틴게일 전략',
    '双马丁策略': '듀얼 마틴게일 전략',
    '做单数量': '주문 수량',
    '止盈回调 (%)': '익절 되돌림 (%)',
    '亏损补偿比例 (%)': '손실 보상 비율 (%)',
    '持仓比例 (%)': '포지션 비율 (%)',
    '恢复后的最大持仓': '재개 후 최대 포지션',
    '做单数量变化时，补仓配置将同步更新。': '주문 수량이 변경되면 추가 매수 설정도 함께 업데이트됩니다.',
    'Astra 最小投入 100 USDT': 'Astra 최소 투자 금액: 100 USDT',
    'U 本位': 'USDT 마진',
    '做多': '롱',
    '做空': '숏',
    '亏损补偿比例': '손실 보상 비율',
    '重置成功后，所有已登录设备将被强制退出；交易所 API 绑定不受影响。': '재설정이 완료되면 로그인된 모든 기기에서 로그아웃됩니다. 거래소 API 연결은 영향을 받지 않습니다.',
    '上一页': '이전',
    '下一页': '다음',
    '收益构成基于本月已结算数据统计，每日 00:00 更新。': '수익 구성은 이번 달 정산 데이터를 기준으로 하며 매일 00:00에 업데이트됩니다.',
    '少': '낮음',
    '本月累计已结算 (USDT)': '이번 달 누적 정산 (USDT)',
    '最佳单日': '최고 수익일',
    '盈利天数': '수익 발생일',
    '日均收益': '일평균 수익',
    '收益日历按自然日统计已结算收益，绿色越深代表当日收益越高；悬停单元格可查看每日明细。': '수익 달력은 날짜별 정산 수익을 표시합니다. 초록색이 진할수록 수익이 높으며 셀에 마우스를 올리면 일별 상세 내역을 볼 수 있습니다.',
    '查看公告、交易动态及系统消息': '공지, 거래 소식 및 시스템 메시지 보기',
    '正在同步未读数量…': '읽지 않은 수를 동기화하는 중…',
    '只读 + 交易授权，无提现权限，资产始终留在你自己的交易所账户': '읽기 및 거래 권한만 부여되며 출금 권한은 없습니다. 자산은 항상 본인의 거래소 계정에 보관됩니다.',
    '支持交易所': '지원 거래소',
    '重新绑定': '다시 연결',
    '已加密保存': '암호화 저장됨',
    '只读': '읽기 전용',
    '禁止提现': '출금 금지',
    '暂无可绑定的交易所': '연결 가능한 거래소가 없습니다',
    '密钥经 AES-256 加密存储，仅用于查询与下单，平台无法提现你的资产；建议在交易所侧同时设置 IP 白名单。': '키는 AES-256으로 암호화되어 조회와 주문에만 사용됩니다. 플랫폼은 자산을 출금할 수 없습니다. 거래소에서 IP 허용 목록도 설정하는 것을 권장합니다.',
    '头像': '프로필 이미지',
    '选择图片': '이미지 선택',
    '支持 JPG / PNG，文件不超过 4MB': 'JPG / PNG 지원, 최대 4MB',
    '昵称将显示在顶栏与收益榜（脱敏展示）': '닉네임은 상단과 수익 순위에 마스킹되어 표시됩니다',
    '更换交易所请返回列表': '거래소를 변경하려면 목록으로 돌아가세요',
    'Passphrase 必须与 OKX 保持一致，不能包含中文、非英文字符或空格': 'Passphrase는 OKX와 일치해야 하며 중국어, 영문 이외의 문자 또는 공백을 포함할 수 없습니다',
    '授权范围': '권한 범위',
    '密钥经 AES-256 加密存储，仅用于查询与下单；请勿开启提现权限，建议同时设置 IP 白名单。': '키는 AES-256으로 암호화되어 조회와 주문에만 사용됩니다. 출금 권한을 활성화하지 말고 IP 허용 목록도 설정하는 것을 권장합니다.',
    '不知道如何创建 API？': 'API 생성 방법을 모르시나요?',
    '查看图文教程': '이미지 가이드 보기',
    '恢复运行': '운영 재개',
    '重新读取': '다시 불러오기',
    '实时同步': '실시간 동기화',
    '至': '~',
    '仓位数据来自当前交易所；暂停策略不会自动平仓。': '포지션 데이터는 현재 거래소에서 가져옵니다. 전략을 일시정지해도 포지션은 자동 청산되지 않습니다.',
    '马丁策略控制': '마틴게일 전략 제어',
    '管理补仓、止盈与循环操作': '추가 매수, 익절 및 반복 작업 관리',
    '当前挂单': '현재 미체결 주문',
    '已实现盈亏': '실현 손익',
    '策略参数': '전략 매개변수',
    '当前策略配置': '현재 전략 설정',
    '当前没有可展示的策略参数': '표시할 전략 매개변수가 없습니다',
    '本次补仓后停止继续补仓': '이번 추가 매수 후 추가 주문 중지',
    '操作完成后同时停止策略': '작업 완료 후 전략도 중지',
    '该循环或网格订单的成交记录': '해당 사이클 또는 그리드 주문의 체결 기록',
    '正在读取成交明细…': '체결 상세 내역을 불러오는 중…',
    '盈亏': '손익'
  }
}
